import { UUID } from "angular2-uuid"
import socialIcons from "../shared/drag-drop-content/elements/social-property/social-icons"
import { FormDragAndDropInterface } from "../shared/drag-drop-content/interfaces/form.interface"
import { ElementInterface } from "../shared/drag-drop-content/interfaces/element.interface"

export const INITIAL_FORM: FormDragAndDropInterface = {
    added_components: [],
    form_design: {
        formType: 'standard',
        form_name: null,
        fullWidth: false,
        width: 600,
        page_alignment: 'top',
        background_color: '#f5f5f5',
        container_background_color: '#ffffff',
        text_color: '#000000',
        font_family: "'Helvetica Neue', Helvetica, sans-serif",
        font_size: 16,
        rounded_corners: 8,
        page_paddings: 15,
        form_paddings: 15,
        field_rounded_corners: 5,
        form_border_width: 1,
        form_border_color: '#ced4da',
        field_background_color: '#ffffff',
        field_border_width: 1,
        field_border_color: '#ced4da',
        label_font_color: '#000000',
        label_font_size: 14,
        label_font_bold: false,
        label_font_italic: false,
        field_size: 'm',
        logic: ""
    },
}

export const TABLE: ElementInterface = {
    name: "Table",
    machineName: 'table',
    iconClass: 'fas fa-table fa-2x',
    addedComponents: [],
    element: {
        field_name: `table-${UUID.UUID()}`,
        label: "table 1",
        border_width: 1,
        border_style: 'solid',
        border_color: '#FFFFFF',
        columns: [{
            id: `col${UUID.UUID().split('-')[0]}`,
            name: "col1",
            valueType: 'text'
        }, {
            id: `col${UUID.UUID().split('-')[0]}`,
            name: "col2",
            valueType: "checkbox"
        }],
        content: 'Button',
        link_to: '',
        button_type: 'button',
        button_style: '',
        button_color: '#0143a3',
        text_color: '#FFFFFF',
        rounded_corners: 0,
        button_size_type: 'full-width',
        button_size: 100,
        font_family: "'Helvetica Neue', Helvetica, sans-serif",
        font_size: 16,
        font_bold: false,
        font_italic: false,
        line_height: 1.5,
        height: 30,
        alignment: 'center',
        vertical_align: 'middle',
        box_shadow_color: '',
        gradient_top_color: '',
        gradient_bottom_color: '',
    },
    deletable: true,
    type: 'text',
}
export const BUTTON: ElementInterface = {
    name: 'Button',
    machineName: 'button',
    iconClass: 'fas fa-square fa-2x',
    addedComponents: [],
    element: {
        content: 'Button',
        link_to: '',
        button_type: 'button',
        button_style: '',
        button_color: '#0143a3',
        text_color: '#FFFFFF',
        rounded_corners: 0,
        button_size_type: 'auto',
        button_size: 100,
        font_family: "'Helvetica Neue', Helvetica, sans-serif",
        font_size: 16,
        font_bold: false,
        font_italic: false,
        line_height: 1.5,
        height: 30,
        alignment: 'center',
        vertical_align: 'middle',
        box_shadow_color: '',
        gradient_top_color: '',
        gradient_bottom_color: '',
    },
    deletable: true,
    type: 'text',
}
export const INPUT: ElementInterface = {
    name: 'Input',
    machineName: 'input',
    iconClass: 'far fa-square fa-2x',
    addedComponents: [],
    element: {
        label: 'Input label',
        field_name: null,
        is_required: false,
        show_label: true,
        placeholder_text: 'Placeholder text',
        prefix: "",
        postfix: ""
    },
    deletable: true,
    type: 'text',
}

export const OUTPUT: ElementInterface = {
    name: 'Output',
    machineName: 'output',
    iconClass: 'fa fa-calculator fa-2x',
    addedComponents: [],
    element: {
        label: 'Output label',
        field_name: null,
        is_required: false,
        show_label: true,
        placeholder_text: 'Placeholder text',
        prefix: "",
        postfix: "",
        formula: ""
    },
    deletable: true,
    type: 'text',
}

export const TEXTAREA: ElementInterface = {
    name: 'Textarea',
    machineName: 'textarea',
    iconClass: 'far fa-window-maximize fa-2x',
    addedComponents: [],
    element: {
        label: 'Textarea label',
        field_name: null,
        is_required: false,
        show_label: true,
        placeholder_text: 'Placeholder text',
    },
    deletable: true,
}
export const DROPDOWN: ElementInterface = {
    name: 'Dropdown',
    machineName: 'dropdown',
    iconClass: 'far fa-caret-square-down fa-2x',
    addedComponents: [],
    element: {
        label: 'Dropdown label',
        options: [
            {
                id: "#Dropdown1",
                text: 'Option1',
                value: 'Value1',
                is_selected: true,
            },
            {
                id: "#Dropdown2",
                text: 'Option2',
                value: 'Value2',
                is_selected: false,
            },
            {
                id: "#Dropdown3",
                text: 'Option3',
                value: 'Value3',
                is_selected: false,
            },
        ],
        is_required: false,
        show_label: true,
        field_name: null,
    },
    deletable: true,
}
export const RADIO_BUTTON: ElementInterface = {
    name: 'Radio buttons',
    machineName: 'radios',
    iconClass: 'fas fa-list-ul fa-2x',
    addedComponents: [],
    element: {
        label: 'Radio buttons label',
        options: [
            {
                id: "#radio1",
                text: 'Option1',
                value: 'Value1',
                is_selected: true,
            },
            {
                id: "#radio2",
                text: 'Option2',
                value: 'Value3',
                is_selected: false,
            },
            {
                id: "#radio3",
                text: 'Option3',
                value: 'Value3',
                is_selected: false,
            },
        ],
        is_required: false,
        show_label: true,
        field_name: null,
    },
    deletable: true,
}
export const CHECKBOX: ElementInterface = {
    name: 'Checkbox',
    machineName: 'checkbox',
    iconClass: 'far fa-check-square fa-2x',
    addedComponents: [],
    element: {
        label: 'Checkbox label',
        field_name: null,
        is_required: false,
    },
    deletable: true,
}
export const TOGGLE: ElementInterface = {
    name: 'Toggle',
    machineName: 'toggle',
    iconClass: 'fa fa-toggle-on fa-2x',
    addedComponents: [],
    element: {
        label: '',
        field_name: null,
        is_required: false,
    },
    deletable: true,
}
export const TEXT: ElementInterface = {
    name: 'Text',
    machineName: 'text',
    iconClass: 'fas fa-language fa-2x',
    addedComponents: [],
    element: {
        content:
            '<p>New Text</p>',
        line_height: 1.5,
        text_color: null,
        font_family: "'Helvetica Neue', Helvetica, sans-serif",
    },
    deletable: true,
}
export const PICTURE: ElementInterface = {
    name: 'Picture',
    machineName: 'picture',
    iconClass: 'far fa-image fa-2x',
    addedComponents: [],
    element: {
        image_url: '',
        image_link: '',
        alignment: 'center',
        alt_text: '',
        width: 0,
    },
    deletable: true,
}
export const SPACER: ElementInterface = {
    name: 'Spacer',
    machineName: 'spacer',
    iconClass: 'fas fa-arrows-alt-v fa-2x',
    addedComponents: [],
    element: {
        height: 30,
    },
    deletable: true,
}
export const SEPERATOR: ElementInterface = {
    name: 'Separator',
    machineName: 'separator',
    iconClass: 'fas fa-grip-lines fa-2x',
    addedComponents: [],
    element: {
        border_style: 'solid',
        border_color: '',
        border_width: 1,
    },
    deletable: true,
}
export const SOCIAL: ElementInterface = {
    name: 'Social',
    machineName: 'social',
    iconClass: 'fas fa-share-alt fa-2x',
    addedComponents: [],
    element: {
        icon_size: '32px',
        alignment: 'left',
        placement: 'horizontally',
    },
    buttons: [
        { ...socialIcons[0], id: UUID.UUID() },
        { ...socialIcons[1], id: UUID.UUID() },
        { ...socialIcons[2], id: UUID.UUID() },
        { ...socialIcons[3], id: UUID.UUID() },
        { ...socialIcons[4], id: UUID.UUID() },
    ],
    deletable: true,
}
export const UPLOADER: ElementInterface = {
    name: 'Uploader',
    machineName: 'uploader',
    iconClass: 'fas fa-upload fa-2x',
    addedComponents: [],
    element: {
        field_name: null,
        upload_url: 'https://example.com/upload-handler',
        accepted_files: 'image/*',
        max_file_size: 2,
        placeholder:
            'Click or drag images here to upload'
        ,
        line_height: 1.5,
        text_color: null,
        font_family: "'Helvetica Neue', Helvetica, sans-serif",
        font_size: 16,
        border_style: 'dashed',
        border_color: '#c7c3c3',
        border_width: 3,
        width_type: 'full-width',
        width: 150,
        alignment: 'center',
    },
    deletable: true,
}

export const LOCATION_SELECTOR: ElementInterface = {
    name: 'Client Location Selector',
    machineName: 'clientLocationSelector',
    iconClass: 'fa fa-location fa-2x',
    addedComponents: [],
    element: {
        label: '',
        field_name: "clientLocation",
        is_required: false,
    },
    deletable: true,
}